import { isNull, isEmpty } from 'lodash';

import { revertPhoneMask } from 'helpers/revert-phone-mask';
import { axiosDelete, axiosGet, axiosPut, axiosPost } from './axios.helpers';

export const showSubLocation = async (id) => axiosGet(`/sublocations/${id}`);

export const updateSubLocation = async (id, subLocation, organizationId) => {
  const {
    nickName,
    room,
    address,
    city,
    state,
    postalCode,
    country,
    contactFirstName,
    contactLastName,
    contactTitle,
    contactEmail,
    contactPhone,
    isVirtual,
  } = subLocation;

  await axiosPut(`/sublocations/${id}`, {
    nick_name: nickName,
    room,
    address: isVirtual ? '' : address,
    city: isVirtual ? '' : city,
    state: isVirtual ? '' : state,
    postal_code: isVirtual ? '' : postalCode,
    country: isVirtual ? '' : country,
    contact_first_name: contactFirstName,
    contact_last_name: contactLastName,
    contact_email: contactEmail,
    is_virtual: isVirtual,
    ...(isEmpty(contactTitle) ? {} : { contact_title: contactTitle }),
    ...(isEmpty(contactPhone)
      ? {}
      : { contact_phone: revertPhoneMask(contactPhone) }),
    org_id: organizationId,
  });
};

export const createSubLocation = async (subLocation, organizationId) => {
  const {
    nickName,
    room,
    address,
    city,
    state,
    postalCode,
    country,
    contactFirstName,
    contactLastName,
    contactTitle,
    contactEmail,
    contactPhone,
    isVirtual,
  } = subLocation;

  await axiosPost('/sublocations', {
    nick_name: isNull(nickName) ? '' : nickName,
    room: isNull(room) ? '' : room,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    ...(isEmpty(contactFirstName)
      ? {}
      : { contact_first_name: contactFirstName }),
    ...(isEmpty(contactLastName) ? {} : { contact_last_name: contactLastName }),
    ...(isEmpty(contactEmail) ? {} : { contact_email: contactEmail }),
    is_virtual: isVirtual,
    ...(isEmpty(contactTitle) ? {} : { contact_title: contactTitle }),
    ...(isEmpty(contactPhone)
      ? {}
      : { contact_phone: revertPhoneMask(contactPhone) }),
    org_id: organizationId,
  });
};

export const deleteSubLocation = async (id) => {
  await axiosDelete(`/sublocations/${id}`);
};
